import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from '../src/pages/Home/Home';
import SearchPage from '../src/pages/Search/Search';
import ExplorePage from '../src/pages/Explore/Explore';
import ReelsPage from '../src/pages/Reels/Reels';
import NotificationsPage from '../src/pages/Notifications/Notifications';
import CreatePage from '../src/pages/Create/Create';


// ---------- Login - Register - Forget password ---------
import LoginPage from './pages/Login/Login';
import RegisterPage from './pages/Register/Register';
import ForgetpassPage from './pages/Forgetpass/Forgetpass';
import RestpassPage from './pages/Forgetpass/Restpass';
import Avatar from './component/Avatar/Avatar';
// -------------------------------------------------------

import NotFoundPage from '../src/pages/NotFound/Notfound';
import UserProfilePage from '../src/pages/Profile/UserProfile';
import ProfilePage from '../src/pages/Profile/Profile';
// import UserCard from '../src/pages/Profile/UserCard';
import { AppContext } from './context/AppContext';

function App() {

  const {user} = useContext(AppContext);

  console.log({user});
  
// const {user} = true;


  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/reels" element={<ReelsPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/create" element={<CreatePage />} />
      {/* <Route path="/profile/:username" element={<ProfilePage />} /> */}
      <Route path="/profile/:user_id/:username" element={<UserProfilePage />} />
      <Route path="/login" element={ user ? <HomePage /> : <LoginPage />} />
      <Route path="/register" element={ user ? <HomePage /> : <RegisterPage />} />
      <Route path="/forgetpass" element={<ForgetpassPage />} />
      
      <Route path="/restpass" element={<RestpassPage />} />
      <Route path="/avatar" element={<Avatar />} />




      <Route />
    </Routes>
  )
}

export default App;

